export default class Likes {
  constructor() {
    this.likes = [];
  }
  addLikes(id, title, image) {
    const like = { id, title, image };
    this.likes.push(like);
    // Persist the data into local storage
    this.persistData();
    return like;
  }
  deleteLike(id) {
    const index = this.likes.findIndex((el) => el.id === id);
    this.likes.slice(index, 1);
    console.log("delete",this.likes.slice(index, 1));
    // Persist the data into local storage
    this.persistData();
  }
  isLiked(id){
      return this.likes.findIndex(el=>el.id===id)!==-1;
  }
  getNumLikes(){
      return this.likes.length;
  }
  persistData(){
    localStorage.setItem("likes",JSON.stringify(this.likes));

  }
  readStorage(){
    const storage=JSON.parse(localStorage.getItem("likes"));
    // Restoring the likes from the local storage
    if(storage) this.likes=storage;
  }

}